export const tablecolumns = [
    {
      Header: 'Name',
      accessor: 'name',
    },
    {
      Header: 'Position',
      accessor: 'position',
    },
    {
      Header: 'Office',
      accessor: 'office',
    },
    {
      Header: 'Age',
      accessor: 'age',
    },
    {
      Header: 'Start date',
      accessor: 'startdate',
    },
    {
      Header: 'Salary',
      accessor: 'salary',
    },
  ];

export const TableData = [
    {
        name: 'Garrett Winters',
        position: 'Accountant',
        office: 'Tokyo',
        age: '63',
        startdate: '2011/07/25',
        salary: '$170,750',
    },
    {
        name: 'Ashton Cox',
        position: 'Junior Technical Author',
        office: 'San Francisco',
        age: '66',
        startdate: '2009/01/12',
        salary: '$86,000',
    },
    {
        name: 'Cedric Kelly',
        position: 'Senior Javascript Developer',
        office: 'Edinburgh',
        age: '22',
        startdate: '2012/03/29',
        salary: '$433,060',
    },
    {
        name: 'Airi Satou',
        position: 'Accountant',
        office: 'Tokyo',
        age: '33',
        startdate: '2008/11/28',
        salary: '$162,700',
    },
    {
        name: 'Brielle Williamson',
        position: 'Integration Specialist',
        office: 'New York',
        age: '61',
        startdate: '2012/12/02',
        salary: '$372,000',
    },
    {
        name: 'Herrod Chandler',
        position: 'Sales Assistant',
        office: 'San Francisco',
        age: '59',
        startdate: '2012/08/06',
        salary: '$137,500',
    },
    {
        name: 'Rhona Davidson',
        position: 'Integration Specialist',
        office: 'Tokyo',
        age: '55',
        startdate: '2010/10/14',
        salary: '$327,900',
    },
    {
        name: 'Colleen Hurst',
        position: 'Javascript Developer',
        office: 'San Francisco',
        age: '39',
        startdate: '2009/09/15',
        salary: '$205,500',
    },
    {
        name: 'Sonya Frost',
        position: 'Software Engineer',
        office: 'Edinburgh',
        age: '23',
        startdate: '2008/12/13',
        salary: '$103,600',
    },
    {
        name: 'Jena Gaines',
        position: 'Office Manager',
        office: 'London',
        age: '30',
        startdate: '2008/12/19',
        salary: '$90,560',
    },
    // {
    //     name: 'Quinn Flynn',
    //     position: 'Support Lead',
    //     office: 'Edinburgh',
    //     age: '22',
    //     startdate: '2013/03/03',
    //     salary: '$342,000',
    // },
    // {
    //     name: 'Charde Marshall',
    //     position: 'Regional Director',
    //     office: 'San Francisco',
    //     age: '36',
    //     startdate: '2008/10/16',
    //     salary: '$470,600',
    // }
]